import type { PartialOnly } from '@ipfabric/utils/types/PartialOnly';
import { z } from 'zod';
import {
  type RegexSiteSeparationRuleBase,
  regexSiteSeparationRuleBaseSchemaZ,
} from './regexSiteSeparationRule';
import {
  type SiteSeparationRuleCommon,
  siteSeparationRuleCommonSchemaZ,
} from './siteSeparationRuleCommon';

export interface CloudResourceIdSiteSeparationRule
  extends SiteSeparationRuleCommon,
    RegexSiteSeparationRuleBase {
  type: 'regexCloudResourceId';
  applyToCloudInstances: boolean;
}

export type CloudResourceIdSiteSeparationRequestRule = PartialOnly<
  CloudResourceIdSiteSeparationRule,
  'id'
>;

export const cloudResourceIdSiteSeparationRuleSchemaZ = z
  .object({
    ...siteSeparationRuleCommonSchemaZ.shape,
    ...regexSiteSeparationRuleBaseSchemaZ.shape,
    type: z.literal('regexCloudResourceId'),
    applyToCloudInstances: z.boolean(),
  })
  .strict();

export const cloudResourceIdSiteSeparationRequestRuleSchemaZ = z
  .object({
    ...cloudResourceIdSiteSeparationRuleSchemaZ.shape,
    id: cloudResourceIdSiteSeparationRuleSchemaZ.shape.id.optional(),
  })
  .strict();
